'use strict';

(function($) {

    var pluginName = 'kumsalAction';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var action = this;


        var Plugin = {
            isInit: false,
            modal: null,
            form: null,
            translation: null,
            submit: function() {
                swal.fire({
                    title: action.translation.title,
                    text: action.translation.text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: action.translation.buttons.confirm,
                    cancelButtonText: action.translation.buttons.cancel,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: function() {
                        return !swal.isLoading();
                    },
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            $.ajax({
                                url: action.modal.find('.kumsal-action-form').attr('action'),
                                type: action.modal.find('.kumsal-action-form').attr('method'),
                                data: new FormData(action.form),
                                processData: !1,
                                contentType: !1
                            }).always(function(response) {

                                if(typeof response.status === 'boolean' && response.status)
                                {
                                    swal.fire({
                                        type: 'success',
                                        title: action.translation.success.title,
                                        html: action.translation.success.text,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });

                                    action.options.actionSuccess(action,response);

                                    action.modal.modal('hide');
                                }
                                else if(typeof response.status === 'number' && response.status == 422)
                                {
                                    try
                                    {
                                        var errors = [];
                                        var message = _translation.datatable.action.failed.text;

                                        $.each(Object.entries(response.responseJSON.errors), function( index, value ) {
                                            errors = errors.concat(value[1]);
                                        });

                                        message = errors.join('<br>');
                                    }catch (e) {}

                                    swal.fire({
                                        type: 'error',
                                        title: _translation.datatable.action.failed.title,
                                        html: message,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });

                                }
                                else
                                {
                                    swal.fire({
                                        type: 'error',
                                        title: _translation.datatable.action.failed.title,
                                        html: _translation.datatable.action.failed.text,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });
                                }
                            })
                        })
                    },
                }).then(function(result){

                    if (result.dismiss === 'cancel') {

                        swal.fire({
                            type: 'error',
                            title: _translation.datatable.action.cancel.title,
                            html: _translation.datatable.action.cancel.text,
                            confirmButtonText: _translation.datatable.buttons.okey,
                        });
                    }
                });
            },
            initModalEvents: function(){
                action.modal.on('hidden.bs.modal', function (e) {
                    action.modal.remove();
                });
                action.modal.on('click','.btn-primary', function (e) {
                    e.preventDefault();
                    action.submit();
                });
                action.modal.on('submit','form.kumsal-action-form',function (e) {
                    action.submit();
                    return false;
                });
            },
            initModal: function(){
                swal.fire({
                    type: 'info',
                    title: _translation.datatable.loading.title,
                    html: _translation.datatable.loading.text,
                    onBeforeOpen: function(){
                        swal.showLoading();
                    },
                    allowOutsideClick: function(){
                        return !swal.isLoading();
                    },
                });

                $.ajax({
                    url: action.options.formAction,
                    type: action.options.formMethod,
                    data: action.options.formData,
                }).always(function(response) {

                    try {
                        swal.close();

                        action.modal = $('body').append(response.modal).children('.modal:last-child');

                        action.form = action.modal.find('form.kumsal-action-form')[0];

                        action.translation = response.translation;

                        action.modal.modal('show');

                        action.modal.kumsalFormElements();

                        action.modal.find('.translate-btn-group').kumsalTranslationSelector();

                        action.initModalEvents();

                        action.options.actionReady(action);
                    }
                    catch (e) {
                        swal.fire({
                            type: 'error',
                            title: _translation.datatable.action.failed.title,
                            html: _translation.datatable.action.failed.text,
                            confirmButtonText: _translation.datatable.buttons.okey,
                        });
                    }
                });

            },
            init: function() {

                action.initModal();

                return action;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            action[funcName] = func;
        });


        if (!action.isInit){
            action.options = options;

            action.options.formAction = action.options.formAction || '';
            action.options.formMethod = action.options.formMethod || 'GET';
            action.options.formData = action.options.formData || {};
            action.options.actionReady = action.options.actionReady || function(action){};
            action.options.actionSuccess = action.options.actionSuccess || function(action){};


            action.init();
        }

        return action;
    };

}(jQuery));

$('document').ready(function () {

    $(document).on('click',".kumsal-action",function( event ) {
        event.preventDefault();

        var options = $(this).data();

        $(this).kumsalAction(options);
    });
});